var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActionPendingModal',{attrs:{"message":"Purchasing the Core Training Bundle"}},[(_vm.purchaseinProgressText)?_c('div',{staticClass:"content-block",domProps:{"innerHTML":_vm._s(_vm.purchaseinProgressText)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }